export function shouldHideAppLogo(pathname) {
  if (
    pathname === '/aircraft-tech-log' ||
    pathname === '/tech-log-review'
  ) {
    return true;
  }

  return false;
}

export function shouldUseCompactAppLogo(pathname, search = '') {
  if (pathname !== '/admin') return false;

  const params = new URLSearchParams(search);
  return params.get('section') === 'operations' &&
    params.get('view') === 'payments';
}
